// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"_1PlVqY","logoLinkImage":"_3OZPk8","svgLogoLink":"_2nxr2_","svgLogo":"_17Bc-6"};